"use client";

import { useRefs, type Refs } from "@mediamonks/react-kit";
import { useAnimation } from "@mediamonks/react-kit/gsap";
import { type ReactElement } from "react";
import { createInAnimation } from "./C102Footer.animations";
import classes from "./C102Footer.module.scss";
import { M1Button, M1ButtonProps } from "../../molecules/M1Button/M1Button.tsx";
import classNames from "clsx";

export type C102FooterProps = {
  cookiePreferencesLabel: string | null | undefined;
  links: Array<M1ButtonProps>;
  secondaryLinks?: Array<M1ButtonProps>;
};

export type C102FooterRefs = Refs<{
  self: HTMLDivElement;
}>;

export function C102Footer({
  links,
  secondaryLinks,
  cookiePreferencesLabel,
}: C102FooterProps): ReactElement {
  const refs = useRefs<C102FooterRefs>();

  useAnimation(() => createInAnimation(refs), [refs]);

  return (
    <div className={classes.c102Footer} ref={refs.self}>
      <ul className={classes.links}>
        {links.map((link, index) => (
          <li key={`${link.href}-${index}`}>
            <M1Button {...link} variant="footer-link" />
          </li>
        ))}
        {cookiePreferencesLabel && (
          <li>
            <M1Button
              id="ot-sdk-btn"
              className={classNames(
                "ot-sdk-show-settings",
                classes.cookieSettings,
              )}
              variant="footer-link"
              children={cookiePreferencesLabel}
            />
          </li>
        )}
      </ul>
      {secondaryLinks && (
        <ul className={classes.links}>
          {secondaryLinks.map((link) => (
            <li key={link.href}>
              <M1Button {...link} variant="footer-link" />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
